/**
 * 地図表示マーカー定義
 */
import L from "leaflet";

export default {
  getIconObj,
  getRegistIconObj,
};

function getIconObj(type, size, anchor) {
  const iconSize = size;
  // デフォルト位置はアイコンの下中央部が指定座標になる位置
  let iconAnchor = [size[0] / 2, size[1]];
  if (anchor) {
    iconAnchor = anchor;
  }
  let iconUrl = null;

  if (type == "current") {
    // 現在位置
    iconUrl = require("../../public/kawabou/img/p_point.png");
  } else if (type == "pointA") {
    // 横断図 地点A
    iconUrl = require("../../public/kawabou/img/a_point.png");
  } else if (type == "pointB") {
    // 横断図 地点B
    iconUrl = require("../../public/kawabou/img/b_point.png");
  } else if (type == "bw") {
    // 破堤点
    iconUrl = require("../../public/kawabou/img/map_icons/breakwater.svg");
  }
  // 水位観測所
  else if (type == "stgFlood") {
    // 氾濫発生（変化なし）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_flood.svg");
  } else if (type == "stgFloodUp") {
    // 氾濫発生（変化量上昇）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_flood_up.svg");
  } else if (type == "stgFloodDown") {
    // 氾濫発生（変化量下降）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_flood_down.svg");
  } else if (type == "stgDanger") {
    // 氾濫危険水位超過（変化なし）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_danger.svg");
  } else if (type == "stgDangerUp") {
    // 氾濫危険水位超過（変化量上昇）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_danger_up.svg");
  } else if (type == "stgDangerDown") {
    // 氾濫危険水位超過（変化量下降）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_danger_down.svg");
  } else if (type == "stgRefuge") {
    // 避難判断水位超過（変化なし）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_refuge.svg");
  } else if (type == "stgRefugeUp") {
    // 避難判断水位超過（変化量上昇）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_refuge_up.svg");
  } else if (type == "stgRefugeDown") {
    // 避難判断水位超過（変化量下降）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_refuge_down.svg");
  } else if (type == "stgCaution") {
    // 氾濫注意水位超過（変化なし）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_caution.svg");
  } else if (type == "stgCautionUp") {
    // 氾濫注意水位超過（変化量上昇）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_caution_up.svg");
  } else if (type == "stgCautionDown") {
    // 氾濫注意水位超過（変化量下降）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_caution_down.svg");
  } else if (type == "stgFldctl") {
    // 水防団待機水位超過（変化なし）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_fldctl.svg");
  } else if (type == "stgFldctlUp") {
    // 水防団待機水位超過（変化量上昇）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_fldctl_up.svg");
  } else if (type == "stgFldctlDown") {
    // 水防団待機水位超過（変化量下降）
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_fldctl_down.svg");
  } else if (type == "stgNomal") {
    // 平常
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_normal.svg");
  } else if (type == "stgNotset") {
    // 基準水位未設定
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_notset.svg");
  } else if (type == "stgMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_water_missing.svg");
  }
  // 雨量観測所
  else if (type == "rnNormal") {
    // 平常
    iconUrl = require("../../public/kawabou/img/map_icons/obs_rain_normal.svg");
  } else if (type == "rnMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_rain_missing.svg");
  }
  // 水質観測所
  else if (type == "qwtrExcess") {
    // 基準値超過
    iconUrl = require("../../public/kawabou/img/map_icons/obs_quality_excess.svg");
  } else if (type == "qwtrNormal") {
    // 平常
    iconUrl = require("../../public/kawabou/img/map_icons/obs_quality_normal.svg");
  } else if (type == "qwtrNotset") {
    // 類型指定なし
    iconUrl = require("../../public/kawabou/img/map_icons/obs_quality_notset.svg");
  } else if (type == "qwtrMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_quality_missing.svg");
  }
  // ダム諸量観測所
  else if (type == "damAbnormal") {
    // 異常洪水時防災操作等実施中
    iconUrl = require("../../public/kawabou/img/map_icons/obs_dam_abnormal.svg");
  } else if (type == "damStorage") {
    // 洪水貯留操作実施中
    iconUrl = require("../../public/kawabou/img/map_icons/obs_dam_storage.svg");
  } else if (type == "damNormal") {
    // 平常
    iconUrl = require("../../public/kawabou/img/map_icons/obs_dam_normal.svg");
  } else if (type == "damMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_dam_missing.svg");
  } else if (type == "damNotset") {
    // 管理外
    iconUrl = require("../../public/kawabou/img/map_icons/obs_dam_notset.svg");
  }
  // 海岸観測所
  else if (type == "coastWarning") {
    // 警戒値超過
    iconUrl = require("../../public/kawabou/img/map_icons/obs_sea_warning.svg");
  } else if (type == "coastCaution") {
    // 注意値超過
    iconUrl = require("../../public/kawabou/img/map_icons/obs_sea_caution.svg");
  } else if (type == "coastNormal") {
    // 平常
    iconUrl = require("../../public/kawabou/img/map_icons/obs_sea_normal.svg");
  } else if (type == "coastNotset") {
    // 基準値未設定
    iconUrl = require("../../public/kawabou/img/map_icons/obs_sea_notset.svg");
  } else if (type == "coastMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_sea_missing.svg");
  }
  // 積雪深観測所
  else if (type == "snw200") {
    // 200cm以上
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_200.svg");
  } else if (type == "snw150") {
    // 150cm～199cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_150.svg");
  } else if (type == "snw100") {
    // 100cm～149cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_100.svg");
  } else if (type == "snw50") {
    // 50cm～99cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_50.svg");
  } else if (type == "snw20") {
    // 20cm～49cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_20.svg");
  } else if (type == "snw5") {
    // 5cm～19cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_5.svg");
  } else if (type == "snw0over") {
    // 0cm～4cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_0_over.svg");
  } else if (type == "snw0") {
    // 0cm
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_0.svg");
  } else if (type == "snwMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_snow_missing.svg");
  }
  // 危機管理型水位観測所
  else if (type == "swstgFlood") {
    // 氾濫開始水位超過
    iconUrl = require("../../public/kawabou/img/map_icons/obs_swstg_flood.svg");
  } else if (type == "swstgDanger") {
    // 危険水位超過
    iconUrl = require("../../public/kawabou/img/map_icons/obs_swstg_danger.svg");
  } else if (type == "swstgStart") {
    // 観測開始水位超過
    iconUrl = require("../../public/kawabou/img/map_icons/obs_swstg_start.svg");
  } else if (type == "swstgNomal") {
    // 平常
    iconUrl = require("../../public/kawabou/img/map_icons/obs_swstg_normal.svg");
  } else if (type == "swstgMissing") {
    // 欠測
    iconUrl = require("../../public/kawabou/img/map_icons/obs_swstg_missing.svg");
  }
  // 河川カメラ
  else if (type == "cctv") {
    iconUrl = require("../../public/kawabou/img/map_icons/obs_camera_river.svg");
  }
  // 簡易カメラ
  else if (type == "scam") {
    iconUrl = require("../../public/kawabou/img/map_icons/obs_camera_simple.svg");
  }
  // 周辺観測所バッジ
  else if (type == "badge") {
    iconUrl = require("../../public/kawabou/img/map_icons/badge.png");
  }

  return L.icon({
    iconUrl: iconUrl,
    iconSize: iconSize,
    iconAnchor: iconAnchor,
  });
}

function getRegistIconObj(fileName, size, anchor) {
  const basePath = "/kawabou/img/map_icons/";
  const iconSize = size;
  // デフォルト位置はアイコンの下中央部が指定座標になる位置
  let iconAnchor = [size[0] / 2, size[1]];
  if (anchor) {
    iconAnchor = anchor;
  }
  let iconUrl = null;
  if (fileName) {
    iconUrl = basePath + fileName;
  } else {
    // ファイル名が指定されない場合は、デフォルトのアイコンを指定
    iconUrl = basePath + "registration_point1.svg";
  }

  return L.icon({
    iconUrl: iconUrl,
    iconSize: iconSize,
    iconAnchor: iconAnchor,
  });
}
